import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HRNotificationPage.css";
import { getToken } from "../utils/cryptoUtils";
import apiClient from "../utils/apiClient";

const NotificationPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ================= FETCH NOTIFICATIONS =================
  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const token = getToken();
      if (!token) {
        console.error("No token found. Please log in.");
        return;
      }

      setLoading(true);

      const response = await apiClient.get("/notifications/");

      // DRF pagination support
      const data = response.data;
      setNotifications(data.results || data);

    } catch (error) {
      console.error(
        error.response?.data || "Error fetching notifications"
      );
    } finally {
      setLoading(false);
    }
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this notification?"
    );
    if (!confirmDelete) return;

    try {
      const token = getToken();
      if (!token) {
        console.error("No token found. Please log in.");
        return;
      }

      await apiClient.delete(`/notifications/${id}/`);

      setNotifications((prev) =>
        prev.filter((notification) => notification.id !== id)
      );

    } catch (error) {
      console.error(
        error.response?.data || "Failed to delete notification"
      );
    }
  };

  // ================= ADD =================
  const handleAdd = () => {
    navigate("/dashboard/ManagerAcess/createnotification");
  };

  // ================= UI =================
  return (
    <div className="notification-page">
      <div className="page-header">
        <h1 className="page-title">Notifications</h1>
        <button className="add-btn" onClick={handleAdd}>
          +
        </button>
      </div>

      {loading ? (
        <p className="loading-text">Loading notifications...</p>
      ) : (
        <table className="notification-table">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Subject</th>
              <th>Valid Until</th>
              <th>Delete</th>
            </tr>
          </thead>

          <tbody>
            {notifications.length > 0 ? (
              notifications.map((notification, index) => (
                <tr key={notification.id}>
                  <td>{index + 1}</td>
                  <td>{notification.subject}</td>
                  <td>
                    {notification.valid_until
                      ? new Date(
                          notification.valid_until
                        ).toLocaleDateString()
                      : "N/A"}
                  </td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(notification.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No notifications found.</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default NotificationPage;
